angular.module('rjmNg.constants').constant 'jobTypes', Object.freeze
  INTERRUPT: 1
  FULL_UPDATE: 2
  STRUCT_SYNC: 5
  DATA_SAMPLE: 6
  REMOTE_QUERY: 7
  DATA_SYNC: 8
  DATA_RESYNC: 9
  TABLE_CONSOLIDATE: 10
  DERIVATIVE_CALC: 11
  VALUE_LOG: 12
  RAW_EXPORT: 14
  ROUTINE: 15
  DATA_BACKUP: 16
  TABLE_REPAIR: 17
  ALTER_TABLE: 18
  UPLOAD_HANDLER: 20
  FILE_DOWNLOAD: 21
  FILE_VALIDATION: 22
  CATEGORY_CACHE: 23
  KEY_GENERATION: 25
  EMAIL_SUMMARY: 26
  CONNECTION_TEST: 27
  CONNECTION_DELETE: 28
  QUERY_CACHE_INVALIDATION: 29
  NEW_CHART_CACHE_INVALIDATION: 30
  TREND_TIMESTAMP_CACHE: 32
  CLIENT_INFRASTRUCTURE_CREATION: 33
  FORCE_INTERRUPT: 35
  ORPHAN_DETECTOR: 36
  PARALLEL_DERIVATIVE_UPDATE: 37
  PROFILE: 40
  PARALLEL_NEW_CHART_CACHE_INVALIDATION: 42
  CONNECTION_DIAGNOSER: 44
  TRACKING_CLEANUP: 45
  QUEUE_CONNECTOR: 46
  BENCHMARK_AGGREGATION: 48
  CLIENT_DATA_OPTIMIZATION: 49
  STRUCTURE_MERGE: 51
  CONVERT_TO_MONGO_MODIFIED: 52
  BATCHEETAH: 55
  BATCHEETAH_IMPORT: 56
  BATCHEETAH_DERIVATIVES: 57
  PARDOT_CLIENT_SYNC: 59
  BACKGROUND_RESYNC: 60
  PDW_EXPORT: 61
  METRIC_MIGRATION: 62
  CLIENT_MIGRATION: 63
  BACKGROUND_DATA_SYNC: 64
  AUTODASH_API_CONNECTION: 72
